/*@ngInject*/
const UITranslateDirective = function (localization, $interpolate) {

    let linkFunction = function ($scope, $elm, $attr, controller, transclusionFn) {

        let key = null;

        transclusionFn($scope, function (clone) {
            let innerHtml = clone[0].nodeValue;

            if(innerHtml) {
                key = $interpolate(innerHtml)($scope);

                localization.getTranslationByKey(key).then(function (translation) {
                    $elm.html(translation ? translation : key.trim());
                });
            }
        });

    };

    return {
        restrict: 'A',
        transclude: true,
        link: linkFunction
    };

};

angular.module('umCore')
    .directive('uiTranslate', UITranslateDirective);
